import { RfxStatus, RfxType } from "newui/features/Rfx/types/rfx.types";
import { RFX_STATUS } from "utils/constants";

export const isRFxClosed = (status: string) => {
	return RFX_STATUS.ACTIVE !== status?.toUpperCase();
};

export const isRfxOnboardingType = (
	rfxType: RfxType | string | undefined | null
): boolean => {
	const code = typeof rfxType === "string" ? rfxType : rfxType?.code;

	return code ? code.toLowerCase() === "onb" : false;
};

export const isRfxStatusMatch = (
	rfxStatus: string,
	expectedStatus: RfxStatus
): boolean => {
	return rfxStatus?.toUpperCase() === expectedStatus?.toUpperCase();
};
